import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const ReturnStudyIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.75 2.25751H2.25C1.425 2.25751 0.75 2.93251 0.75 3.75751V6.75001H2.25V3.74251H15.75V14.265H2.25V11.25H0.75V14.2575C0.75 15.0825 1.425 15.7425 2.25 15.7425H15.75C16.575 15.7425 17.25 15.0825 17.25 14.2575V3.75751C17.25 2.92501 16.575 2.25751 15.75 2.25751Z"
        fill={getThemeColor("icon-color")}
      />
      <path
        d="M8.25 12L11.25 9L8.25 6V8.25H0.75V9.75H8.25V12Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default ReturnStudyIcon;
